<fieldset class="catalog-attachments">
  <legend class="catalog-attachments__label ui-body-m">
    <rds-icon class="catalog-attachments__clip" namespace="outlined" icon="attachment" aria-hidden="true" />
    @if (required()) {
      <span class="catalog-attachments__asterisk" aria-hidden="true">*</span>
    }
    {{ TEXTS.LABEL }}
    @if (required()) {
      <span class="sr-only">{{ TEXTS.REQUIRED_SR }}</span>
    }
  </legend>

  <rds-upload
    size="s"
    hasDropZone
    [uploader]="uploader"
    [beforeAddFn]="beforeAdd"
    [disabled]="disabled()"
  >
    @if (error(); as message) {
      <rds-upload-error role="alert" class="catalog-attachments__error">{{ message }}</rds-upload-error>
    }
    @for (message of rejectionMessages(); track $index) {
      <rds-upload-error role="alert">{{ message }}</rds-upload-error>
    }
  </rds-upload>

  @if (rows().length > 0) {
    <ul class="catalog-attachments__list" [attr.aria-label]="TEXTS.LIST_LABEL">
      @for (row of rows(); track row.item.id) {
        <li class="catalog-attachments__row">
          @if (row.thumbnailUrl) {
            <img class="catalog-attachments__thumb" [src]="row.thumbnailUrl" alt="" />
          } @else {
            <rds-icon
              class="catalog-attachments__thumb catalog-attachments__thumb--icon"
              namespace="outlined"
              icon="file"
              aria-hidden="true"
            />
          }
          <span class="catalog-attachments__name">{{ row.name }} ({{ row.size }})</span>
          <button
            rds-icon-button
            size="s"
            type="button"
            [disabled]="disabled()"
            [attr.aria-label]="TEXTS.REMOVE_FILE_NAMED(row.name)"
            (click)="remove(row)"
          >
            <rds-icon namespace="outlined" icon="close" />
          </button>
        </li>
      }
    </ul>
  }

  <p class="sr-only" aria-live="polite">{{ liveMessage() }}</p>
</fieldset>
